export default __webpack_public_path__ + "static/media/shop.ed729a3c.svg";